/** エラーオブジェクトからメッセージを取得する共通ユーティリティ */
export const getErrorMessage = (error: unknown, defaultMessage: string): string => {
  if (error instanceof Error) {
    return error.message;
  }
  return defaultMessage;
};
